import React, { Component, Fragment } from "react";
import Chart from "react-apexcharts";
import util from "../TesteNovoJSON/Util/util";
import Select from "../Grafico/Select";

export default class Grafico2 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mes: "Anual",
            modalidade: "5 Iniciação Profissional",
            unidade: "DR",
            metas: [],
            nomeCampo: "Matrículas",
            dados: [],
            realizados: [],
            acumulado: {},
            selectUnidade: "DR",
            selectModalidade: "5 Iniciação Profissional",
            selectMetaRealizado: "metas",
            selectCampo: "matricula",
            series: [
                {
                    name: "Pago",
                    data: []
                },
                {
                    name: "Gratuidade Regimental",
                    data: []
                },
                {
                    name: "Gratuidade Não-Regimental",
                    data: []
                }
            ],
            options: {
                chart: {
                    height: 350,
                    type: 'line',
                    dropShadow: {
                        enabled: true,
                        color: '#000',
                        top: 18,
                        left: 7,
                        blur: 10,
                        opacity: 0.2
                    },
                    toolbar: {
                        show: false
                    }
                },
                colors: ['#77B6EA', '#545454', '#FEBC3B', "#51CBCE"],
                dataLabels: {
                    enabled: true,
                    formatter: function (value) {
                        return value.toLocaleString("pt-BR", { maximumFractionDigits: 2, style: 'decimal' });
                    },
                    background: {
                        enabled: true,
                        //foreColor: ['#77B6EA', '#545454', '#FEBC3B', 'transparent'],
                        borderWidth: 1,
                    },
                },
                stroke: {
                    curve: 'smooth'
                },
                title: {
                    text: 'Total',
                    align: 'left'
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'],
                        opacity: 0.5
                    },
                },
                markers: {
                    size: 1
                },
                xaxis: {
                    categories: ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"],
                    title: {
                        text: 'Mês'
                    }
                },
                yaxis: {
                    title: {
                        text: 'TOTAL'
                    },
                    //min: 5,
                    //max: 40,
                    //opposite: true,
                    labels: {
                        formatter: function (value) {
                            if (Number.isFinite(value)) {
                                return value.toLocaleString("pt-BR", { maximumFractionDigits: 2, style: 'decimal' });
                            }
                            else {
                                return 0
                            }
                        }

                    }
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'right',
                    floating: true,
                    offsetY: -25,
                    offsetX: -5,
                    formatter: function(seriesName, opts) {
                        seriesName = seriesName === "Total" ? "Total" : seriesName;
                        return [seriesName]
                    }
                }
            }

            /*
            series: [
                {
                    name: 'Actual',
                    data: [
                        {
                            x: '2011',
                            y: 1292,
                            goals: [
                                {
                                    name: 'Expected',
                                    value: 1400,
                                    strokeHeight: 5,
                                    strokeColor: '#775DD0'
                                }
                            ]
                        },
                        {
                            x: '2012',
                            y: 4432,
                            goals: [
                                {
                                    name: 'Expected',
                                    value: 5400,
                                    strokeHeight: 5,
                                    strokeColor: '#775DD0'
                                }
                            ]
                        },
                        {
                            x: '2013',
                            y: 5423,
                            goals: [
                                {
                                    name: 'Expected',
                                    value: 5200,
                                    strokeHeight: 5,
                                    strokeColor: '#775DD0'
                                }
                            ]
                        },
                        {
                            x: '2014',
                            y: 6653,
                            goals: [
                                {
                                    name: 'Expected',
                                    value: 6500,
                                    strokeHeight: 5,
                                    strokeColor: '#775DD0'
                                }
                            ]
                        },
                        {
                            x: '2015',
                            y: 8133,
                            goals: [
                                {
                                    name: 'Expected',
                                    value: 6600,
                                    strokeHeight: 13,
                                    strokeWidth: 0,
                                    strokeLineCap: 'round',
                                    strokeColor: '#775DD0'
                                }
                            ]
                        },
                        {
                            x: '2016',
                            y: 7132,
                            goals: [
                                {
                                    name: 'Expected',
                                    value: 7500,
                                    strokeHeight: 5,
                                    strokeColor: '#775DD0'
                                }
                            ]
                        },
                        {
                            x: '2017',
                            y: 7332,
                            goals: [
                                {
                                    name: 'Expected',
                                    value: 8700,
                                    strokeHeight: 5,
                                    strokeColor: '#775DD0'
                                }
                            ]
                        },
                        {
                            x: '2018',
                            y: 6553,
                            goals: [
                                {
                                    name: 'Expected',
                                    value: 7300,
                                    strokeHeight: 2,
                                    strokeDashArray: 2,
                                    strokeColor: '#775DD0'
                                }
                            ]
                        }
                    ]
                }
            ],
            options: {
                chart: {
                    height: 350,
                    type: 'bar'
                },
                plotOptions: {
                    bar: {
                        columnWidth: '60%'
                    }
                },
                colors: ['#00E396'],
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: true,
                    showForSingleSeries: true,
                    customLegendItems: ['Actual', 'Expected'],
                    markers: {
                        fillColors: ['#00E396', '#775DD0']
                    }
                }
            }
            */

    }
}

async componentDidMount() {
    this.calculaTipoPorMes();
}

calculaTipoPorMes = async (event) => {
    let valor = event ? event.target.value : null;
    let id = event ? event.target.id : null;

    let { selectUnidade, selectModalidade, selectMetaRealizado, selectCampo } = this.state;
    let { dados, realizados, acumulado } = await util.fetchDados(this.state.mesSelecionado, false);


    if (id === "selectUnidade") {
        selectUnidade = valor;
    }
    if (id === "selectModalidade") {
        selectModalidade = valor;
    }
    if (id === "selectMetaRealizado") {
        selectMetaRealizado = valor;
    }
    if (id === "selectCampo") {
        selectCampo = valor;
    }

    let indice = dados && dados.findIndex(unidade => unidade.unidade === selectUnidade);

    let realizado1 = new Array(12).fill(0);
    let realizado2 = new Array(12).fill(0);
    let realizado3 = new Array(12).fill(0);

    try {
        realizado1 = dados[indice] && dados[indice][selectMetaRealizado][selectModalidade] && dados[indice][selectMetaRealizado][selectModalidade][`${selectCampo}_regimental`]     ? dados[indice][selectMetaRealizado][selectModalidade][`${selectCampo}_regimental`]     : realizado1;
        realizado2 = dados[indice] && dados[indice][selectMetaRealizado][selectModalidade] && dados[indice][selectMetaRealizado][selectModalidade][`${selectCampo}_nao_regimental`] ? dados[indice][selectMetaRealizado][selectModalidade][`${selectCampo}_nao_regimental`] : realizado2;
        realizado3 = dados[indice] && dados[indice][selectMetaRealizado][selectModalidade] && dados[indice][selectMetaRealizado][selectModalidade][`${selectCampo}_pago`]           ? dados[indice][selectMetaRealizado][selectModalidade][`${selectCampo}_pago`]           : realizado3;
    }
    catch (erro) {
    }

    this.setState({
        series: [
            {
                name: "Pago",
                data: realizado3
            },
            {
                name: "Gratuidade Regimental",
                data: realizado1
            },
            {
                name: "Gratuidade Não-Regimental",
                data: realizado2
            }
        ],
        options: {
            title: {
                text: `Unidade`
            }
        },
        selectUnidade,
        selectModalidade,
        dados,
        realizados,
        acumulado,
        selectCampo
    });
}

render() {
    return (
        <Fragment>

            <div className="row">
                <div className="col-md-12">
                    <div className="card ">
                        <div className="card-header ">
                            <div className="row">
                                <div className="col-md-4">
                                    <h5 className="card-title">{this.state.nomeCampo}</h5>
                                    <h6>{this.state.modalidade}</h6>
                                </div>
                                <div className="col-md-2">
                                    <Select select={this.calculaTipoPorMes} campo="campos" idComponente="selectCampo" />
                                </div>
                                <div className="col-md-2">
                                    <Select select={this.calculaTipoPorMes} campo="tipos" idComponente="selectMetaRealizado" />
                                </div>
                                <div className="col-md-2">
                                    <Select select={this.calculaTipoPorMes} campo="unidades" idComponente="selectUnidade" />
                                </div>
                                <div className="col-md-2">
                                    <Select select={this.calculaTipoPorMes} />
                                </div>
                            </div>
                        </div>
                        <div className="card-body ">
                            <div className="mixed-chart">
                                <Chart options={this.state.options} series={this.state.series} type="line" height={"300"} />
                            </div>
                        </div>
                        <div className="card-footer ">
                            <hr />
                            <div className="stats">
                                <i className="fa fa-history"></i> {new Date().toLocaleDateString("pt-br", { dateStyle: "full" })}
                                {/*
                                    <span style={{ float: 'right' }}>
                                        <button className="btn btn-outline-primary btn-round btn-sm" style={{ fontSize: '0.500em' }}>
                                            Visão Unidades
                                        </button>
                                    </span>
                                */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Fragment>
    )
}
}